@if (!hideGamingCrossSellByArc) {
    <a class="banner-content ms-active-highlight" (click)="onBannerClick()">
        @if (showThemeIcon) {
            <span class="banner-theme-icon" [ngClass]="model.themeIcon"></span>
        } @else if (model.imageUrl) {
            <img placeholder class="banner-image" fetchpriority="high" ngSrcset="1x, 2x, 3x" [width]="48" [height]="48" [ngSrc]="model.imageUrl" />
        }
        <div class="banner-info">
            <div class="banner-title">{{ model.title }}</div>
            <div class="banner-text">{{ model.text }}</div>
        </div>
        <span class="banner-theme-right"><vn-icon name="theme-right" size="13" /></span>
    </a>
}
